import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Table } from "react-bootstrap";
import api from "../../../api";
import styles from "./index.module.scss";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import { getFilterCatalogState } from "../../../redux/selectors";
import { getCatalogsByType } from "../../../redux/reducers";
import CatalogRow from "./Row";

const CatalogDetails = () => {
  const params: any = useParams();
  const { catalogs, error, loader } = useAppSelector((state) =>
    getFilterCatalogState(state)
  );
  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch(getCatalogsByType(params.catalogType));
  }, []);
  return loader ? (
    <>Загрузка</>
  ) : error ? (
    <>Произошла Ошибка</>
  ) : catalogs.catalogs.length == 0 ? (
    <>Пусто</>
  ) : (
    <div className={styles.root + " container"}>
      <Table>
        <thead>
          <tr>
            <th>Имя товара </th>
            <th>Описание</th>
            <th>Цена </th>
            <th>Кол-во</th>
            <th>Фотография</th>
            <th>Действие </th>
          </tr>
        </thead>
        <tbody>
          {catalogs.catalogs.map(
            ({
              amount,
              catalogId,
              catalogName,
              catalogType,
              description,
              image,
              price,
            }) => (
              <CatalogRow
                amount={amount}
                catalogId={catalogId}
                catalogName={catalogName}
                catalogType={catalogType}
                description={description}
                image={image}
                price={price}
                key={catalogId}
              />
            )
          )}
        </tbody>
      </Table>
    </div>
  );
};

export default CatalogDetails;
